/* TBC bundles: what the cart's bundle state means for the rest of the store.

   The discount is the store's, by the cart's content. This script reads the
   theme's own rules and the cart, through sections/tbc-bundle-state.liquid
   (Section Rendering API), and never a discount app's data; the one thing it
   writes for an app is the line marks of a BOGOS Mix & match offer (below,
   before refresh()):

   Everything below shows only for pieces that complete a bundle: the cart
   holds pieces of a set, and this piece serves a step the cart lacks.

   1. Cards: the price the piece would take in the bundle, as a stamp or a
      second price line (snippets/tbc-bundle-stamp.liquid, [data-tbc-bundle]).
   2. Quick add: the same price as one line in the panel
      (snippets/tbc-quick-add-panel.liquid, [data-tbc-bundle-line]).
   3. Collections: one banner above the grid naming what the cart has and
      what this collection adds (snippets/tbc-bundle-banner.liquid).

   When the store's discount took a different percent off than the tiers in
   Theme settings say (state.mismatch), nothing here promises a price.

   Without the automatic discount switched on (Theme settings > Bundles)
   nothing shows. */

(function () {
  var state = null;
  var pending = null;
  /* The page's fetch before this script wraps it (see the end): the
     script's own requests never wait on themselves. */
  var baseFetch = window.fetch.bind(window);

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function money(cents) {
    var format = String((window.theme && window.theme.moneyFormat) || '${{amount}}').replace(/<[^>]*>/g, '');
    var value = Math.round(cents) / 100;
    function fixed(decimals, thousands, decimal) {
      var parts = value.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount_no_decimals': return fixed(0, ',', '.');
        case 'amount_with_comma_separator': return fixed(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fixed(0, '.', ',');
        case 'amount_with_apostrophe_separator': return fixed(2, "'", '.');
        case 'amount_with_space_separator': return fixed(2, ' ', ',');
        default: return fixed(2, ',', '.');
      }
    });
  }

  function load(fresh) {
    if (pending && !fresh) return pending;
    pending = baseFetch(root() + 'cart?section_id=tbc-bundle-state', { headers: { Accept: 'text/html' } })
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (html) {
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var parsed = JSON.parse(holder.textContent.trim() || 'null');
        state = parsed && parsed.engine === 'automatic' ? parsed : null;
        return state;
      })
      .catch(function () {
        state = null;
        return null;
      })
      .then(function (result) {
        pending = null;
        return result;
      });
    return pending;
  }

  function bundle(number) {
    if (!state) return null;
    return state.bundles.filter(function (item) { return String(item.n) === String(number); })[0] || null;
  }

  function percentAt(set, count) {
    var percent = 0;
    set.tiers.forEach(function (tier) {
      if (tier[0] <= count && tier[1] > percent) percent = tier[1];
    });
    return percent;
  }

  function filled(set, step) {
    return set.filled.map(String).indexOf(String(step)) !== -1;
  }

  /* The percent this piece would take: the tier for the cart's pieces plus
     this one, when the cart has started the set and lacks this piece's step. */
  function offerFor(number, productId, step) {
    var set = bundle(number);
    if (!set || set.pieces < 1 || set.mismatch) return null;
    if (step && filled(set, step)) return null;
    if (set.products.map(String).indexOf(String(productId)) !== -1) return null;
    var percent = percentAt(set, set.pieces + 1);
    return percent > 0 ? { percent: percent, set: set } : null;
  }

  function fill(node, template, values) {
    if (!node) return;
    node.textContent = String(template || '').replace(/__(\w+)__/g, function (match, key) {
      return values[key.toLowerCase()] != null ? values[key.toLowerCase()] : '';
    });
  }

  /* The sentence with the percent (and its sign) as the one red figure. */
  function fillWithPercent(node, values) {
    if (!node) return;
    var template = String(node.getAttribute('data-template') || '');
    function words(text) {
      return document.createTextNode(text.replace(/__(\w+)__/g, function (match, key) {
        return values[key.toLowerCase()] != null ? values[key.toLowerCase()] : '';
      }));
    }
    var at = template.indexOf('__PERCENT__');
    if (at === -1) {
      node.replaceChildren(words(template));
      return;
    }
    var rest = template.slice(at + 11);
    var sign = rest.charAt(0) === '%' ? '%' : '';
    var figure = document.createElement('span');
    figure.className = 'tbc-bundle-banner__percent';
    figure.textContent = values.percent + sign;
    node.replaceChildren(words(template.slice(0, at)), figure, words(rest.slice(sign.length)));
  }

  function stamp(card) {
    var mark = card.querySelector('[data-tbc-bundle-stamp]');
    if (!mark) return;
    var offer = offerFor(card.getAttribute('data-tbc-bundle'), card.getAttribute('data-product-id'), card.getAttribute('data-tbc-bundle-step'));
    if (!offer) {
      mark.hidden = true;
      return;
    }
    var price = Number(card.getAttribute('data-tbc-bundle-price')) || 0;
    var values = {
      percent: offer.percent,
      price: money(price * (100 - offer.percent) / 100),
      was: money(price)
    };
    mark.querySelectorAll('[data-template]').forEach(function (node) {
      fill(node, node.getAttribute('data-template'), values);
    });
    mark.hidden = false;
  }

  function line(node) {
    var offer = offerFor(node.getAttribute('data-tbc-bundle-line'), node.getAttribute('data-product-id'), node.getAttribute('data-tbc-bundle-step'));
    if (!offer) {
      node.hidden = true;
      return;
    }
    var price = Number(node.getAttribute('data-price')) || 0;
    fill(node, node.getAttribute('data-template'), {
      percent: offer.percent,
      price: money(price * (100 - offer.percent) / 100),
      was: money(price)
    });
    node.hidden = false;
  }

  /* A collection no step lists (Bayoneta headgear with cheeks, facebars):
     the step most of its product cards belong to, when they are at least
     half the grid. */
  function stepOfCards(node) {
    var scope = node.parentElement || document;
    var cards = scope.querySelectorAll('[data-grid-item]');
    if (!cards.length) return null;
    var counts = {};
    var best = null;
    cards.forEach(function (card) {
      var number = card.getAttribute('data-tbc-bundle');
      var step = card.getAttribute('data-tbc-bundle-step');
      if (!number || !step) return;
      var key = number + ':' + step;
      counts[key] = (counts[key] || 0) + 1;
      if (!best || counts[key] > counts[best]) best = key;
    });
    if (!best || counts[best] * 2 < cards.length) return null;
    var parts = best.split(':');
    var set = ((state && state.bundles) || []).filter(function (item) { return String(item.n) === parts[0]; })[0];
    var step = set && set.steps.filter(function (item) { return String(item.id) === parts[1]; })[0];
    return step ? { set: set, step: step } : null;
  }

  function banner(node) {
    var id = node.getAttribute('data-collection-id');
    var match = null;
    ((state && state.bundles) || []).some(function (set) {
      var step = set.steps.filter(function (item) {
        return item.collections.some(function (entry) { return String(entry.id) === String(id); });
      })[0];
      if (step) match = { set: set, step: step };
      return Boolean(step);
    });
    if (!match) match = stepOfCards(node);
    var set = match && match.set;
    var percent = set && set.pieces > 0 && !set.mismatch && !filled(set, match.step.id) ? percentAt(set, set.pieces + 1) : 0;
    if (!percent) {
      node.hidden = true;
      return;
    }
    var have = set.steps
      .filter(function (item) { return filled(set, item.id); })
      .map(function (item) { return String(item.title || '').toLowerCase(); })
      .join(' + ');
    var values = {
      have: have,
      need: match.step.phrase || String(match.step.title || '').toLowerCase(),
      percent: percent
    };
    var haveNode = node.querySelector('[data-tbc-bundle-banner-have]');
    fill(haveNode, haveNode.getAttribute('data-template'), values);
    fillWithPercent(node.querySelector('[data-tbc-bundle-banner-need]'), values);

    /* The cart row's segments: one per step, the steps the cart fills in ink. */
    var bar = node.querySelector('[data-tbc-bundle-banner-bar]');
    if (bar) {
      bar.style.setProperty('--pieces', set.steps.length);
      bar.replaceChildren();
      set.steps.forEach(function (item) {
        var segment = document.createElement('span');
        if (filled(set, item.id)) segment.className = 'is-filled';
        bar.appendChild(segment);
      });
    }
    var link = node.querySelector('[data-tbc-bundle-banner-link]');
    if (link) {
      link.hidden = !set.link;
      if (set.link) link.href = set.link;
    }
    node.hidden = false;
  }

  function paint(scope) {
    var area = scope || document;
    area.querySelectorAll('[data-tbc-bundle]').forEach(stamp);
    area.querySelectorAll('[data-tbc-bundle-line]').forEach(line);
    area.querySelectorAll('[data-tbc-bundle-banner]').forEach(banner);
  }

  /* A bundle whose discount is a code (its name in Theme settings > Bundles)
     gets that code once the cart reaches the first tier: the app that owns
     it only adds it to a cart with no code, so a welcome code applied first
     would keep it out. The codes already there stay; the store takes the
     best discount on each line. The page's cart is rebuilt afterwards only
     when asked (rebuild), not when a cart request is waiting on it. */
  function rebuild() {
    /* The theme's rebuild announces theme:cart:change itself. */
    var items = document.querySelector('cart-items');
    if (items && typeof items.getCart === 'function') items.getCart();
    else refresh();
  }

  function addCodes(again) {
    var wanted = ((state && state.bundles) || []).filter(function (set) {
      return set.code && set.current > 0;
    }).map(function (set) { return set.code; });
    if (!wanted.length) return Promise.resolve(false);
    return baseFetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (entry) { return entry.code; });
        var lower = codes.map(function (code) { return code.toLowerCase(); });
        var missing = wanted.filter(function (code) { return lower.indexOf(code.toLowerCase()) === -1; });
        if (!missing.length) return false;
        return post('cart/update.js', { discount: codes.concat(missing).join(',') }).then(function () {
          if (again) rebuild();
          return true;
        });
      })
      .catch(function () { return false; });
  }

  /* A bundle priced by a BOGOS Mix & match offer (its ID in Theme settings >
     Bundles): the offer's code discounts only the lines carrying the trigger
     properties its own widget writes, whatever their count per mix item. So
     the cart writes them itself on one line per step, mix item N being step
     N: a second glove is never a piece. Below the first tier, or once a line
     stops being its step's piece, the marks come off. A line holding several
     units is split so a single unit carries them. A few rebuilt passes per
     page at most, in case an app rewrites the lines in between. */
  var MARKS = ['_bogos_trigger_id', '_bogos_trigger', '_bogos_trigger_type', '_bogos_code'];
  var marking = null;
  var markPasses = 0;

  function post(path, body) {
    return baseFetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error(path);
      return response.json();
    });
  }

  function withoutMarks(properties) {
    var out = {};
    Object.keys(properties || {}).forEach(function (key) {
      if (MARKS.indexOf(key) === -1) out[key] = properties[key];
    });
    return out;
  }

  function markedStep(item) {
    var trigger = String((item.properties || {})._bogos_trigger || '');
    var match = trigger.match(/_(\d+)$/);
    return match ? match[1] : '';
  }

  function jobsFor(set, cart) {
    var offer = String(set.offer);
    var stepOf = {};
    (set.lines || []).forEach(function (line) { stepOf[line.key] = String(line.step); });
    var mine = cart.items.filter(function (item) {
      return String((item.properties || {})._bogos_trigger_id || '') === offer;
    });

    var chosen = {};
    mine.forEach(function (item) {
      var step = stepOf[item.key];
      if (step && !chosen[step] && markedStep(item) === step) chosen[step] = item;
    });
    cart.items.forEach(function (item) {
      var step = stepOf[item.key];
      if (step && !chosen[step]) chosen[step] = item;
    });
    var steps = Object.keys(chosen);
    var live = set.current > 0 && steps.length > 1;

    var jobs = [];
    mine.forEach(function (item) {
      if (live && chosen[stepOf[item.key]] === item) return;
      jobs.push(function () {
        return post('cart/change.js', { id: item.key, quantity: item.quantity, properties: withoutMarks(item.properties) });
      });
    });
    if (!live) return jobs;

    var base = '';
    steps.forEach(function (step) {
      var trigger = String((chosen[step].properties || {})._bogos_trigger || '');
      if (!base && trigger.indexOf('MM_' + offer + '_') === 0) base = trigger.replace(/_\d+$/, '');
    });
    if (!base) base = 'MM_' + offer + '_' + chosen[steps[0]].product_id + '_r' + Math.random().toString(36).slice(2, 8);

    steps.forEach(function (step) {
      var item = chosen[step];
      var properties = withoutMarks(item.properties);
      properties._bogos_trigger_id = offer;
      properties._bogos_trigger = base + '_' + step;
      properties._bogos_trigger_type = 'mix_match';
      if (set.offer_link) properties._bogos_code = set.offer_link;
      var current = item.properties || {};
      var same = MARKS.every(function (key) { return String(current[key] || '') === String(properties[key] || ''); });
      if (same && item.quantity === 1) return;
      if (item.quantity > 1) {
        jobs.push(function () {
          return post('cart/change.js', { id: item.key, quantity: item.quantity - 1, properties: withoutMarks(item.properties) });
        });
        jobs.push(function () {
          return post('cart/add.js', { items: [{ id: item.variant_id, quantity: 1, properties: properties }] });
        });
      } else {
        jobs.push(function () {
          return post('cart/change.js', { id: item.key, quantity: 1, properties: properties });
        });
      }
    });
    return jobs;
  }

  function markLines(again) {
    var sets = ((state && state.bundles) || []).filter(function (set) { return set.offer; });
    if (!sets.length) return Promise.resolve(false);
    if (marking) return marking;
    if (again && markPasses > 3) return Promise.resolve(false);
    if (again) markPasses += 1;
    marking = baseFetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var jobs = [];
        sets.forEach(function (set) { jobs = jobs.concat(jobsFor(set, cart)); });
        if (!jobs.length) return false;
        return jobs.reduce(function (chain, job) { return chain.then(job); }, Promise.resolve())
          .then(function () { return true; });
      })
      .catch(function () { return false; })
      .then(function (changed) {
        marking = null;
        if (changed && again) rebuild();
        return changed;
      });
    return marking;
  }

  function refresh() {
    load().then(function () {
      paint();
      markLines(true).then(function (changed) {
        if (!changed) addCodes(true);
      });
    });
  }

  /* Every add to cart in the store (product forms, quick add, the Build
     page, Complete the set, the apps) ends in a POST to /cart/add,
     /cart/change or /cart/update. Each one waits here, after the store
     answers, until the bundle's lines are marked and its code is on the
     cart, so whatever draws the cart next shows the bundle price at once,
     never the full one first. */
  var CART_WRITE = /\/cart\/(add|change|update)(\.js)?(\?|$)/;

  function settle() {
    return load(true)
      .then(function () { return markLines(false); })
      .then(function () { return addCodes(false); });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : String((input && input.url) || '');
    var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    var request = baseFetch(input, init);
    if (method !== 'POST' || !CART_WRITE.test(url)) return request;
    if (state && !state.bundles.some(function (set) { return set.offer || set.code; })) return request;
    return request.then(function (response) {
      if (!response.ok) return response;
      return settle().then(function () { return response; }, function () { return response; });
    });
  };

  /* Cards and quick add content can arrive after load (new arrivals, the
     quick add panel); paint what arrives with the state already in hand. */
  function watch() {
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (records) {
      if (!state) return;
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches('[data-tbc-bundle], [data-tbc-bundle-line]')) paint(node.parentNode);
          else if (node.querySelector('[data-tbc-bundle], [data-tbc-bundle-line]')) paint(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('theme:cart:change', refresh);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refresh(); watch(); });
  } else {
    refresh();
    watch();
  }

  window.TBCBundles = { load: load, state: function () { return state; }, offerFor: offerFor, money: money, refresh: refresh };
})();
